<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
    }
  },
  mounted() {
    this.adaptMobile()
    window.addEventListener('resize', this.adaptMobile);
  },
  methods: {
    adaptMobile() {
      const isMobile = window.innerWidth < 900;
      const designWidth = 1920;
      const html = document.documentElement;
      if (isMobile) {
        const scale = window.innerWidth / designWidth;
        html.style.transform = `scale(${scale})`;
        html.style.transformOrigin = 'top left';
        html.style.width = `${designWidth}px`;
        html.style.overflowX = 'hidden';
      } else {
        html.style.transform = 'none';
        html.style.width = 'auto';
      }
    }

  }
}
</script>

<style>
html,
body {
  width: 100%;
  box-sizing: border-box;
  padding: 0px;
  margin: 0px;
  background-color: #EAEDF4;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  widows: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue